/**
 * Created by lenovo on 2017/3/28.
 */
import React,{Component} from 'react'
import {Link} from 'react-router'
import {language,getUserId,resultTip} from 'UTIL/common'
export default class FormInputSimple extends Component{
    render(){
        return (
            <div className="row form-group">
                <label  className="multi-label control-label col-xs-2">{language()[this.props.name]} </label>
                <div className="col-xs-3">
                    <input type="text" className="form-control" autocomplete="off"
                           placeholder={language()[this.props.name]} id={this.props.id}  />
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./modules/component/form/formInputSimple.js